import { useIntl } from '@grandvisionhq/state';
import { useFramesEcommContext } from '../context/FramesEcommContext.js';

const useFramesPriceFrom = ()=>{
    const { getLabel  } = useIntl();
    const { shouldDisplayFromPrice  } = useFramesEcommContext();
    const fromPricePrefix = shouldDisplayFromPrice ? getLabel('products.price.frames.from', {
        hideLabelKey: true
    }) : undefined;
    return {
        shouldDisplayFromPrice,
        fromPricePrefix
    };
};

export { useFramesPriceFrom };
//# sourceMappingURL=use-frames-price-from.js.map
